import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FileSaver from 'file-saver';
import { connect } from 'react-redux';
import { Button } from '@mui/material';
import {
    Spinner,
} from '../..';
import { http } from '../../../helpers';
import './styles.scss';

class Download extends Component {
    constructor() {
        super();
        this.state = {
            failedPdf: false,
            failedOrderIntegrationUploadZip: false,
            failedZip: false,
            fetchingPdf: false,
            fetchingOrderIntegrationUploadZip: false,
            fetchingZip: false,
        };
    }

    getCaseStatus = async (id) => http.get(`/case-api/cases/${id}/status`)
        .then(({ data: { status } }) => status)
        .catch((error) => console.warn(error));

    updateCaseStatusToAccepted = async (id) => http.post(`/case-api/cases/${id}/status/accepted`)
        .then(({ data: { status } }) => status)
        .catch((error) => console.warn(error));

    handleRXDownload = (id, id8, uri, canUpdateCaseStatus) => {
        const { updateCaseStatus } = this.props;
        this.setState({ failedPdf: false, fetchingPdf: true });
        http.getBlob(uri, 'application/pdf')
            .then(async (response) => {
                const blob = new Blob([response.data], {
                    type: 'application/pdf',
                });
                FileSaver.saveAs(blob, `prescription_${id8}.pdf`);
                if (canUpdateCaseStatus) {
                    await this.updateCaseStatusToAccepted(id);
                    const status = await this.getCaseStatus(id);
                    updateCaseStatus(id, status); // update status of the case ties to this rx
                }
            })
            .catch(() => {
                this.setState({ failedPdf: true });
                console.warn('Download failed.');
            })
            .finally(() => this.setState({ fetchingPdf: false }));
    };

    handleOrderIntegrationUploadZIPDownload = (uri, id8) => {
        this.setState({ failedOrderIntegrationUploadZip: false, fetchingOrderIntegrationUploadZip: true });
        http.getBlob(uri, 'application/zip')
            .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/zip',
                });
                FileSaver.saveAs(blob, `order_integration_upload_${id8}.zip`);
            })
            .catch(() => {
                this.setState({ failedOrderIntegrationUploadZip: true });
                console.warn('Download failed.');
            })
            .finally(() => this.setState({ fetchingOrderIntegrationUploadZip: false }));
    };

    handleZIPDownload = (uri, id8) => {
        this.setState({ failedZip: false, fetchingZip: true });
        http.getBlob(uri, 'application/zip')
            .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/zip',
                });
                FileSaver.saveAs(blob, `scan_${id8}.zip`);
            })
            .catch(() => {
                this.setState({ failedZip: true });
                console.warn('Download failed.');
            })
            .finally(() => this.setState({ fetchingZip: false }));
    };

    renderDownloadButton = ({
        label,
        fileType,
        hasFailed,
        isFetching,
        onClick,
    }) => (
        <Button
            className="download-action-button more-padding"
            onClick={onClick}
            disabled={isFetching || hasFailed}
            sx={{ border: 1, borderColor: 'divider' }}
        >
            <span className={`download-button-icon ${hasFailed ? 'failed' : ''}`} aria-hidden="true">
                {
                    isFetching
                        ? <Spinner type="inline-bigger" />
                        : (
                            <i className="material-icons">
                                {hasFailed ? 'warning' : 'download'}
                            </i>
                        )
                }
            </span>
            <span className="download-button-text">
                <span className="name">{label}</span>
                <span className="type">{fileType}</span>
            </span>
        </Button>
    );

    render() {
        const {
            id,
            id8,
            orderIntegrationUploadZipUrl,
            prescriptionUrl,
            scanZipUrl,
            canDownloadPrescription,
            canDownloadOrderIntegrationUploadZip,
            canUpdateCaseStatus,
            canDownloadSTL,
        } = this.props;
        const {
            failedPdf,
            failedOrderIntegrationUploadZip,
            failedZip,
            fetchingPdf,
            fetchingOrderIntegrationUploadZip,
            fetchingZip,
        } = this.state;

        return (
            <div className="downloads-menu">
                {
                    canDownloadPrescription
                        && this.renderDownloadButton({
                            label: 'Prescription',
                            fileType: '.pdf',
                            hasFailed: failedPdf,
                            isFetching: fetchingPdf,
                            onClick: () => this.handleRXDownload(id, id8, prescriptionUrl, canUpdateCaseStatus),
                        })
                }
                {
                    canDownloadSTL
                        && this.renderDownloadButton({
                            label: 'Scans',
                            fileType: '.zip',
                            hasFailed: failedZip,
                            isFetching: fetchingZip,
                            onClick: () => this.handleZIPDownload(scanZipUrl, id8),
                        })
                }
                {
                    canDownloadOrderIntegrationUploadZip
                        && this.renderDownloadButton({
                            label: 'Order',
                            fileType: '.zip',
                            hasFailed: failedOrderIntegrationUploadZip,
                            isFetching: fetchingOrderIntegrationUploadZip,
                            onClick: () => this.handleOrderIntegrationUploadZIPDownload(orderIntegrationUploadZipUrl, id8),
                        })
                }
            </div>
        );
    }
}

Download.propTypes = {
    id: PropTypes.string.isRequired,
    id8: PropTypes.string.isRequired,
    orderIntegrationUploadZipUrl: PropTypes.string,
    prescriptionUrl: PropTypes.string,
    scanZipUrl: PropTypes.string,
    updateCaseStatus: PropTypes.func.isRequired,
    canDownloadOrderIntegrationUploadZip: PropTypes.bool.isRequired,
    canDownloadPrescription: PropTypes.bool.isRequired,
    canUpdateCaseStatus: PropTypes.bool.isRequired,
    canDownloadSTL: PropTypes.bool.isRequired,
};

Download.defaultProps = {
    orderIntegrationUploadZipUrl: '',
    prescriptionUrl: '',
    scanZipUrl: '',
};

const mapDispatchToProps = (dispatch) => ({
    updateCaseStatus: (id, status) => dispatch({ type: 'UPDATE_CASE_STATUS', id, status }),
});

export default connect(null, mapDispatchToProps)(Download);
